export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      Result: 'success',
      Modifys: [
        {
          ModifyId: 3,
          ModifyContent: 'xxxxxx',
          CreatedAt: '2019-08-02',
          UpdatedAt: '2019-09-20'
        },
        {
          ModifyId: 2,
          ModifyContent: 'yyyyy',
          CreatedAt: '2019-08-02',
          UpdatedAt: '2019-09-20'
        },
        {
          ModifyId: 1,
          ModifyContent: 'zzzzzz',
          CreatedAt: '2019-08-02',
          UpdatedAt: '2019-09-20'
        }
      ]
    }
  }
}